import InuxePopup, {
  ConfirmActionButtons,
  ConfirmPopup,
  PopupFooter,
  PopupIcon,
  POPUP_VARIANTS,
  DEFAULT_ICON_BACKGROUND,
  DEFAULT_ICON_COLOR,
} from '@inuxe/common-popup';

export {
  ConfirmActionButtons,
  ConfirmPopup,
  PopupFooter,
  PopupIcon,
  POPUP_VARIANTS,
  DEFAULT_ICON_BACKGROUND,
  DEFAULT_ICON_COLOR,
};

export { InuxePopup as Popup };
export default InuxePopup;

export type {
  ConfirmActionButtonsProps,
  ConfirmActionTone,
  ConfirmIntent,
  ConfirmPopupProps,
  IconSize,
  IconThemeProps,
  PopupFooterAlign,
  PopupFooterProps,
  PopupIconProps,
  PopupProps,
  PopupVariant,
  PopupVariantTheme,
} from '@inuxe/common-popup';
